import React from 'react';
import styled from 'styled-components';
import { useUser } from '../../hooks/useUser';
import { mediaQuery, typography } from '../../theme';
import { Button } from '../button/Button';
import LinkNoPrefetch from '../linkNoPrefetch/LinkNoPrefetch';
import { colors } from '../../theme/color';

type LinkProps = {
  url?: string;
  text: string;
  icon: React.ReactNode;
  onClick: () => void;
  hideCC?: boolean;
};

export const MenuLink: React.FC<LinkProps> = ({ onClick, url, text, icon, hideCC }) => {
  const { isCCUser } = useUser();

  if (hideCC && isCCUser) {
    return null;
  }

  if (url) {
    return (
      <StyledNavLink href={url} onClick={onClick}>
        {icon}
        {text}
      </StyledNavLink>
    );
  }
  return (
    <StyledButton onClick={onClick}>
      {icon}
      {text}
    </StyledButton>
  );
};

const StyledNavLink = styled(LinkNoPrefetch)`
  ${typography.linkStyle}
  color: ${colors.textDefault};
  margin-bottom: 0.25em;
  padding: 0.25em;
  text-decoration: none;
  display: flex;
  align-items: center;
  border-radius: 8px;

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme?.color.primary};
  }

  &:hover {
    color: ${colors.black};
  }

  & svg {
    margin: 0 0.25em 0 0;
    font-size: 1.5rem;
    width: 1.5rem;
    height: 1.5rem;
  }

  @media ${mediaQuery.tablet} {
    font-size: 0.875rem;
  }
`;

const StyledButton = styled(Button)`
  ${typography.linkStyle}
  color: ${colors.textDefault};
  margin-bottom: 0.25em;
  padding: 0.25em;
  text-decoration: none;
  display: flex;
  align-items: center;
  border-radius: 8px;
  background-color: transparent;
  border: none;
  font-weight: 400;

  & div {
    gap: 0;
    ${typography.linkStyle}
    color: ${colors.textDefault};
    font-size: 1rem;
    line-height: 1.15;
    text-decoration: none;

    @media ${mediaQuery.tablet} {
      font-size: 0.875rem;
    }
  }

  &:focus-visible {
    outline: 2px solid ${colors.green.base};
    background-color: transparent;
  }

  &:hover {
    outline: none;
    color: ${colors.black};
    background-color: transparent;
  }

  & svg {
    margin: 0 0.25em 0 0;
    font-size: 1.5rem;
    width: 1.5rem;
    height: 1.5rem;
  }
`;
